const IamAssignmentsIconSubcategory = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4434_11488)" />
    <path
      d="M40.7239 47.8613C38.1429 47.8613 35.5619 47.8613 32.9809 47.8613C31.7979 47.8613 30.8838 47.0009 30.8838 45.818C30.8838 44.6888 31.7979 43.7747 32.9809 43.7747C38.1429 43.7747 43.3587 43.7747 48.5207 43.7747C49.6499 43.7747 50.4565 44.5275 50.6178 45.6029C50.7253 46.6245 50.0801 47.5386 49.0046 47.8075C48.8433 47.8613 48.682 47.8613 48.5207 47.8613C45.8859 47.8613 43.3049 47.8613 40.7239 47.8613Z"
      fill="white"
    />
    <path
      d="M22.5 46.7749H24.5V44.7749H22.5V46.7749ZM26.5 47.7749C26.5 48.3272 26.0523 48.7749 25.5 48.7749H21.5C20.9477 48.7749 20.5 48.3272 20.5 47.7749V43.7749C20.5 43.2226 20.9477 42.7749 21.5 42.7749H25.5C26.0523 42.7749 26.5 43.2226 26.5 43.7749V47.7749Z"
      fill="white"
    />
    <path
      d="M40.7231 23.1231C43.3579 23.1231 45.9389 23.1231 48.5737 23.1231C49.5416 23.1231 50.4019 23.8759 50.5632 24.79C50.7245 25.8117 50.1868 26.7795 49.1652 27.0484C48.9501 27.1559 48.735 27.1559 48.5199 27.1559C43.3041 27.1559 38.0883 27.1559 32.8725 27.1559C31.7971 27.1559 30.9368 26.3494 30.8292 25.274C30.7217 24.2523 31.4207 23.3382 32.4961 23.1231C32.6575 23.0693 32.8188 23.0693 32.9801 23.0693C35.5611 23.1231 38.1421 23.1231 40.7231 23.1231Z"
      fill="white"
    />
    <path
      d="M22.979 24.8885C23.7318 24.1357 24.3771 23.3829 25.0761 22.6839C25.3987 22.3612 25.6676 22.0386 25.9902 21.716C26.6355 21.0707 27.5496 21.0707 28.1948 21.6622C28.8401 22.2537 28.8401 23.2216 28.2486 23.8668C27.0119 25.2111 25.7751 26.5016 24.5384 27.7921C23.463 28.9213 21.8499 28.76 20.9357 27.4695C20.5056 26.8242 20.0754 26.179 19.6452 25.5337C19.1613 24.7272 19.3226 23.813 20.0754 23.3291C20.7744 22.8452 21.7423 23.0603 22.28 23.8131C22.4951 24.1357 22.7102 24.5121 22.979 24.8885Z"
      fill="white"
    />
    <path
      d="M40.6702 37.4261C38.0891 37.4261 35.5081 37.4261 32.9271 37.4261C31.9592 37.4261 31.0989 36.7809 30.8838 35.9206C30.5612 34.63 31.5291 33.3933 32.8196 33.3933C35.1317 33.3933 37.4439 33.3933 39.756 33.3933C42.6597 33.3933 45.6171 33.3933 48.5207 33.3933C49.4348 33.3933 50.2952 34.0923 50.4565 34.9527C50.6716 35.8668 50.2414 36.8347 49.3811 37.2111C49.0584 37.3724 48.682 37.4261 48.3594 37.4261C45.886 37.4261 43.2512 37.4261 40.6702 37.4261Z"
      fill="white"
    />
    <path
      d="M22.979 34.6568C23.7318 33.904 24.3771 33.1512 25.0761 32.4522C25.3987 32.1295 25.6676 31.8069 25.9902 31.4843C26.6355 30.839 27.5496 30.839 28.1948 31.4305C28.8401 32.022 28.8401 32.9899 28.2486 33.6351C27.0119 34.9794 25.7751 36.2699 24.5384 37.5604C23.463 38.6896 21.8499 38.5283 20.9357 37.2378C20.5056 36.5925 20.0754 35.9473 19.6452 35.302C19.1613 34.4955 19.3226 33.5814 20.0754 33.0974C20.7744 32.6135 21.7423 32.8286 22.28 33.5814C22.4951 33.904 22.7102 34.2804 22.979 34.6568Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4434_11488"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7000FF" />
        <stop offset="1" stop-color="#45009C" />
      </linearGradient>
    </defs>
  </svg>
)

export default IamAssignmentsIconSubcategory
